import Vue from 'vue';
import Router from 'vue-router';
import BaseLayout from '@/views/BaseLayout/';
import Login from '@/views/Login/';
import store from '../store/index';
import SesionService from '../services/SesionService';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Login
		},
		{
			path: '/primerLogin',
			component: () => import('../views/Login/components/firstLogin.vue')
		},
		{
			path: '/',
			component: BaseLayout,
			children: [
				{
					path: '/usuarios',
					name: 'Users',
					component: () => import('../views/Users/')
				},
				{
					path: '/usuarios/crearUsuario',
					name: 'CreateUser',
					component: () => import('../views/Users/components/CreateEditUser.vue')
				},
				{
					path: '/usuarios/cambiarRole/:id',
					name: 'ChangeRoleUser',
					component: () => import('../views/Users/components/changeUserRole.vue')
				},
				{
					path: '/usuarios/:id',
					name: 'ViewUser',
					component: () => import('../views/Users/components/viewUser.vue')
				},
				{
					path: '/usuarios/editar/:id',
					name: 'CreateEditUser',
					component: () => import('../views/Users/CreateEditUser.vue')
				},
				{
					path: '/legajos',
					component: () =>
						import(/* webpackChunkName: "legajos" */ '../views/family')
				},
				{
					path: '/familia/:id',
					component: () =>
						import(
							/* webpackChunkName: "legajos" */ '../views/family/ViewFamily.vue'
						)
				},
				{
					path: '/conformarFamilia',
					component: () =>
						import(
							/* webpackChunkName: "legajos" */ '../views/family/CreateEditFamily.vue'
						)
				},
				{
					path: '/editarFamilia/:id',
					component: () =>
						import(
							/* webpackChunkName: "legajos" */ '../views/family/CreateEditFamily.vue'
						)
				},

				{
					path: '/chico/:id',
					component: () =>
						import(
							/* webpackChunkName: "legajos" */ '../views/family/ViewChild.vue'
						)
				},
				{
					path: '/agregarChico',
					component: () =>
						import(
							/* webpackChunkName: "legajos" */ '../views/family/CreateEditChild.vue'
						)
				},
				{
					path: '/editarChico/:id',
					component: () =>
						import(
							/* webpackChunkName: "legajos" */ '../views/family/CreateEditChild.vue'
						)
				},

				{
					path: '/equipos',
					component: () =>
						import(/* webpackChunkName: "equipos" */ '../views/teams/Teams.vue')
				},
				{
					path: '/equipo/:id',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/teams/components/viewTeam.vue'
						)
				},
				{
					path: '/conformarEquipo',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/teams/components/formTeam.vue'
						)
				},
				{
					path: '/editarEquipo/:id',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/teams/components/formTeam.vue'
						)
				},

				{
					path: '/categorias',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/category/Categories.vue'
						)
				},
				{
					path: '/categoria/:id',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/category/components/viewCategory.vue'
						)
				},
				{
					path: '/crearCategoria',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/category/components/formCategory.vue'
						)
				},
				{
					path: '/editarCategoria/:id',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/category/components/formCategory.vue'
						)
				},
				{
					path: '/settings',
					component: () =>
						import(/* webpackChunkName: "equipos" */ '../views/settings')
				},
				{
					path: '/datos',
					component: () => import(/* webpackChunkName: "equipos" */ '../views/data')
				},
				{
					path: '/crearDato',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/data/CreateEditData.vue'
						)
				},
				{
					path: '/datos/:id',
					component: () =>
						import(/* webpackChunkName: "equipos" */ '../views/data/ViewData')
				},
				{
					path: '/editarDato/:id',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/data/CreateEditData'
						)
				},

				{
					path: '/documentos',
					component: () =>
						import(/* webpackChunkName: "equipos" */ '../views/document')
				},
				{
					path: '/crearDocumento',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/document/CreateEditDocument.vue'
						)
				},
				{
					path: '/documentos/:id',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/document/ViewDocument'
						)
				},
				{
					path: '/editarDocumento/:id',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/document/CreateEditDocument'
						)
				},
				{
					path: '/notificacion',
					component: () =>
						import(/* webpackChunkName: "equipos" */ '../views/notification')
				},
				{
					path: '/records',
					component: () =>
						import(/* webpackChunkName: "equipos" */ '../views/records')
				},
				{
					path: '/records/crearFicha',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/records/CreateEditRecord'
						)
				},
				{
					path: '/records/verFicha/:id',
					component: () =>
						import(/* webpackChunkName: "equipos" */ '../views/records/ViewRecord')
				},
				{
					path: '/records/editarFicha/:id',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/records/CreateEditRecord'
						)
				},
				//
				{
					path: '/options',
					component: () =>
						import(/* webpackChunkName: "equipos" */ '../views/options')
				},
				{
					path: '/options/crearOpcion',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/options/CreateEditOption'
						)
				},
				{
					path: '/options/verOpcion/:id',
					component: () =>
						import(/* webpackChunkName: "equipos" */ '../views/options/ViewOption')
				},
				{
					path: '/options/editarOpcion/:id',
					component: () =>
						import(
							/* webpackChunkName: "equipos" */ '../views/options/CreateEditOption'
						)
				},
				{
					path: '/etiquetas',
					name: 'Etiquetas',
					component: () => import(/* webpackChunkName: "tags" */ '../views/tags'),
					children: []
				},
				{
					path: '/createTag',
					name: 'CreateTag',
					component: () =>
						import(/* webpackChunkName: "newTag" */ '../views/tags/NewTag.vue')
				},
				{
					path: '/viewTag/:id',
					name: 'ViewTag',
					component: () =>
						import(/* webpackChunkName: "viewTag" */ '../views/tags/ViewTag.vue')
				},
				{
					path: '/editTag/:id',
					name: 'EditTag',
					component: () =>
						import(/* webpackChunkName: "editTag" */ '../views/tags/EditTag.vue')
				},
				{
					path: '/reportes',
					component: () =>
						import(/* webpackChunkName: "legajos" */ '../views/reportes')
				}
			]
		},
		{
			path: '*',
			redirect: '/'
		}
	]
});

router.beforeEach((to, from, next) => {
	const goingToSettingsRelated =
		(from.path === '/crearDato' && to.path === '/settings') ||
		(from.path === '/settings' && to.path === '/crearDato') ||
		(from.path === '/notificacion' && to.path === '/settings') ||
		(from.path === '/crearDocumento' && to.path === '/settings') ||
		(from.path === '/settings' && to.path === '/crearDocumento');

	store.dispatch('settingsStore/setFetchSettingsData', !goingToSettingsRelated);

	const publicPages = ['/', "/primerLogin"];
	const isPublic = publicPages.includes(to.path);

	if (!isPublic && (!SesionService.isAuthenticated() || !(SesionService.tokenExists()))) {
		SesionService.logout();
		return;
	}

	next();
});

export default router;
